// Tiny helper for the admin pages.
// Token kept in localStorage; admin attaches it on every protected call.

const API = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "sa_admin_token";

export const adminApi = {
    getToken: () => localStorage.getItem(TOKEN_KEY),
    setToken: (t) => localStorage.setItem(TOKEN_KEY, t),
    clearToken: () => localStorage.removeItem(TOKEN_KEY),

    async login(email, password) {
        const r = await fetch(`${API}/api/admin/login`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email, password }),
        });
        if (!r.ok) {
            const e = await r.json().catch(() => ({}));
            throw new Error(e.detail || "Login fehlgeschlagen");
        }
        const data = await r.json();
        adminApi.setToken(data.token);
        return data;
    },

    async authedFetch(path, opts = {}) {
        const token = adminApi.getToken();
        const r = await fetch(`${API}${path}`, {
            ...opts,
            headers: {
                ...(opts.headers || {}),
                Authorization: token ? `Bearer ${token}` : "",
            },
        });
        if (r.status === 401) {
            adminApi.clearToken();
            throw new Error("UNAUTHORIZED");
        }
        return r;
    },

    async me() {
        const r = await adminApi.authedFetch("/api/admin/me");
        if (!r.ok) throw new Error("auth failed");
        return r.json();
    },

    async emails(limit = 500) {
        const r = await adminApi.authedFetch(`/api/admin/emails?limit=${limit}`);
        if (!r.ok) throw new Error("emails failed");
        return r.json();
    },

    async stats(days = 30, mode = "all") {
        const r = await adminApi.authedFetch(
            `/api/admin/stats/summary?days=${days}&mode=${mode}`,
        );
        if (!r.ok) throw new Error("stats failed");
        return r.json();
    },

    async sessions(date = "", mode = "all", limit = 200) {
        const params = new URLSearchParams({ mode, limit: String(limit) });
        if (date) params.set("date", date);
        const r = await adminApi.authedFetch(`/api/admin/sessions?${params}`);
        if (!r.ok) throw new Error("sessions failed");
        return r.json();
    },

    async stickerRequests(limit = 500) {
        const r = await adminApi.authedFetch(
            `/api/admin/sticker-requests?limit=${limit}`,
        );
        if (!r.ok) throw new Error("sticker requests failed");
        return r.json();
    },

    exportEmailsUrl() {
        // Browser download – token via query is not supported; we trigger a
        // fetch + blob URL instead from the dashboard.
        return `${API}/api/admin/emails/export`;
    },
};
